import React from 'react';
import CodeHighlight from '../CodeHighlight';
import CopyToClipboardButton from '../CopyToClipboardButton';

const TabBody = ({ editDisabled, tabs, activeTab, handleTitleChange, handleContentChange }) => {
    return (
        <div className="tab-content-container">
            <div className="title-row">
                <textarea
                    className="title-textarea"
                    placeholder="Untitled"
                    rows={1}
                    readOnly={editDisabled}
                    value={tabs[activeTab].title}
                    onChange={handleTitleChange}
                />
                {editDisabled === 1 && <CopyToClipboardButton text={tabs[activeTab].content} />}
            </div>

            {!editDisabled && (
                <textarea
                    className="content-textarea"
                    placeholder="Start typing or paste your code here..."
                    value={tabs[activeTab].content}
                    onChange={handleContentChange}
                    wrap="soft"
                    spellCheck={false}
                    autoFocus
                />
            )}

            {editDisabled === 1 && <CodeHighlight code={tabs[activeTab].content} />}
        </div>
    );
};

export default TabBody;
